import angular from 'angular';

import { routesConfig } from './tasks.overview.routes';

export default angular
  .module('tasks.overview', ['ngResource'])
  .config(routesConfig);
